import { render, staticRenderFns } from "./RealVideoCompnentSRS.vue?vue&type=template&id=ee13cd14&scoped=true"
import script from "./RealVideoCompnentSRS.vue?vue&type=script&lang=js"
export * from "./RealVideoCompnentSRS.vue?vue&type=script&lang=js"
import style0 from "./RealVideoCompnentSRS.vue?vue&type=style&index=0&id=ee13cd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee13cd14",
  null
  
)

export default component.exports